<template>
  <form @submit.prevent="">
    <div class="form-fields">
      <VFormInput
        placeholder="Enter accessory name"
        label="Name*"
        @update="value => $emit('set', 'name', value)"
        :initialValue="initialValues.name"
        :error="errors.name"
      />
      <VFormInput
        placeholder="Enter buy link"
        label="Buy Link*"
        :initialValue="initialValues.shop_link"
        :error="errors.shop_link"
        @update="value => $emit('set', 'shop_link', value)"
      />
      <VFormTextarea
        placeholder="Enter accessory description"
        label="Description*"
        :initialValue="initialValues.description"
        :error="errors.description"
        @update="value => $emit('set', 'description', value)"
      />
      <div class="w-2/5">
        <VFormUploadImage
          :initialSrc="initialValues.thumbnail_path"
          @upload="file => $emit('set', 'thumbnail', file)"
        />
      </div>
      <VFormCheckbox
        label="Promote on Dashboard"
        labelPosition="top"
        :isToggle="true"
        :initialValue="!!initialValues.is_dashboard"
        @update="value => $emit('set', 'is_dashboard', value ? 1 : 0)"
      />
    </div>
  </form>
</template>

<script>
import VFormInput from '@/components/base/VFormInput';
import VFormTextarea from '@/components/base/VFormTextarea';
import VFormUploadImage from '@/components/base/VFormUploadImage';
import VFormCheckbox from '@/components/base/VFormCheckbox';

export default {
  name: 'AccessoryForm',
  components: {
    VFormInput,
    VFormTextarea,
    VFormUploadImage,
    VFormCheckbox,
  },
  computed: {
    seriesOptions() {
      return this.series.map(serie => serie.name);
    },
  },
  data() {
    return {
      checkedItems: [],
    };
  },
  watch: {
    checkedItems(accessories) {
      this.$emit('set', 'accessories', accessories);
    },
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    series: {
      type: Array,
      required: false,
      default: () => [],
    },
    accessories: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>
